import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSalesOnOrderSearchCriteria,
  CustomerSearchCriteria,
  CustomerServiceSalesOrderPrintOutRequest,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestVendorPurchaseOnOrderListRequest,
  SalesPersonBean,
  VendorOnOrderPrintRequest,
  VendorPurchaseOnOrderDetailsBean,
  VendorPurchaseOnOrderSearchCriteria,
} from "../ds/ds.js";
import { DeleteIcon, } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  ColumnDefinition,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupPurchaseOrderModule,
  PopupSalesModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService.js";
import CustomTable from "../gui_components/CustomTable.js";
class CustomerServiceSalesOrder extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Customer Service SalesOrder Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      salesPersons: [],
      salesPersonBean: new SalesPersonBean(),
      summaryData: null,
      criteria: new CustomerSalesOnOrderSearchCriteria(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowInvoiceModule: false,
      isShowVendorQtyPopup: false,
      moduleForPopup: [],
      isCollapsible_open: true,
      customerData: null,
      spData: null,
      salesPersonDatas: [],
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      showAutoCompleteFabricList: true,
      fabricPageListForAutoCompleteList: new Array(),
      salesPersonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      cities: [],
      moduleForPopup: [],
      vendorPurchaseBean: new VendorPurchaseOnOrderDetailsBean(),
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      isDisableFields: false,
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let salesPersons = attribute_cache.salesPersons;
    if (salesPersons != null || salesPersons != undefined) {
      salesPersons.map((attr) => {
        this.state.salesPersons.push(attr);
      });
    }
    let cities = attribute_cache.cities;
    if (cities != null || cities != undefined) {
      cities.map((cities) => {
        this.state.cities.push(cities);
      });
    }
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
      isShowColorLookup: false,
    });
  };
  onChange = (e) => {
    let temp_criteria = this.state.criteria;
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  onCityChange = (e) => {
    let cityCode = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(cityCode)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_criteria = this.state.criteria;
      temp_criteria.cityCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: temp_criteria,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && cityCode !== "") {
      this.readcityBySearchString(cityCode);
    }
    if (e.target.name == "cityCode") {
      temp_criteria["cityCode"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_criteria["cityCode"] = city.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ criteria: temp_criteria });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEvent = (e) => {
    let temp_criteria = this.state.criteria;
    let cityCode = e.target.value;
    temp_criteria["cityCode"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.cityCode = cityBean.code;
      this.setState({
        criteria: temp_criteria,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  salesPersonCodeOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      let criteria = this.state.criteria;
      criteria.salesPersonCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
        salesPersonBean: null,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonBySearchString(salesPersonCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
    this.readSalesPerson(salesPersonCode);
  };
  readSalesPerson = (salesPersonCode) => {
    let salesPersonBean = null;
    this.state.salesPersons.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.salesPersonCode = salesPersonBean.code;
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ salesPersonBean: salesPersonBean });
  };

  readSalesPersonBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersons;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  salesPersonEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPerson(salesPersonCode);
    this.setState({
      salesPersonPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
  };
  displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.colorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let colorCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.colorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = ""; //Added Line
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
    // this.readandsetFabricStyleDetail(fabricStyleCode);
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isFabricStyleDataLoding: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
          });
        }
      }
    }
  };
  readandsetFabricStyleDetailError = (error) => {
    this.setState({ isFabricStyleDataLoding: false });
    ShowError("Error : ", error);
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    // this.setState({
    //   isShowProgressBarPopup: true,
    //   progressLoadingText: "Reading FabricStyle ...",
    // });
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.readandsetFabricStyleDetailError
    );
  };

  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.readByFabricCodeResponseError
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByFabricCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  fabricEnterKeyEventHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(e.target.value);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    CustomerService.readCustomer(
      readrestInput,
      this.editCustomerResponse,
      this.editCustomerError
    );
  };

  editCustomerResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  editCustomerError = (error) => {
    ShowError("Error : ", error);
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.readItemByCustomerCodeError
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readItemByCustomerCodeError = (error) => {
    ShowError("Error : " + error);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomer(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadCustomerSalesOnOrderInquiryList(criteria);
  };
  loadCustomerSalesOnOrderInquiryList = (criteria) => {
    if (SecurityAccessManager.CustomerServiceSalesOrderInquiry_IsAccessible()) {
      ReportService.inquireCustomerSalesOrderService(
        criteria,
        this.loadCustomerSalesOnOrderPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCustomerSalesOnOrderPageResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null && response.data.result != null) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.result.onOrderInfoDetails)) {
        resultList = response.data.result.onOrderInfoDetails;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowProgressBarPopup: false,
        inquiryDataList: resultList,
        isCollapsible_open: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new CustomerSalesOnOrderSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.customerName = "";
    this.setState({
      criteria: tempCriteria,
      isShowColorLookup: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new Array(),
      colorList: [],
      salesPersonDatas: [],
      salesPersonData: [],
      salesPersonBean: new SalesPersonBean(),
      isDisableFields: false,
    });
  };
  resetInquiry = () => {
    let tempCriteria = new CustomerSalesOnOrderSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.customerName = "";
    this.setState({
      criteria: tempCriteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isCollapsible_open: true,
      isShowColorLookup: false,
      salesPersonDatas: [],
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new Array(),
      colorList: [],
      salesPersonData: [],
      salesPersonBean: new SalesPersonBean(),
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let request = new CustomerServiceSalesOrderPrintOutRequest();
    request.criteria = criteria;
    request.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.CustomerServiceSalesOrderPDFReport_IsAccessible()
      ) {
        ReportService.generateCustomerServiceSalesOrderPrintOutReport(
          request,
          this.generateCustomerServiceSalesOrderPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CustomerServiceSalesOrderExcelReport_IsAccessible()
      ) {
        ReportService.generateCustomerServiceSalesOrderPrintOutReport(
          request,
          this.generateCustomerServiceSalesOrderPageExcelResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCustomerServiceSalesOrderPageResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generateCustomerServiceSalesOrderPageExcelResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  addSalesPerson = () => {
    let criteria = this.state.criteria;
    criteria.salesPersonCode = "";
    let salesPersonBean = this.state.salesPersonBean;
    let salesPersonDatas = this.state.salesPersonDatas;
    if (salesPersonBean != null) {
      if (!isEmptyArray(salesPersonDatas)) {
        let exists = salesPersonDatas.find(
          (p) => p.code === salesPersonBean.code
        );
        if (!exists) {
          salesPersonDatas.push(salesPersonBean);
          criteria.salesPersonCodes.push(salesPersonBean.code);
          this.setState({
            criteria: criteria,
            salesPersonDatas: salesPersonDatas,
            salesPersonBean: null,
          });
        }
      } else {
        if (!isEmptyString(salesPersonBean.code)) {
          salesPersonDatas.push(salesPersonBean);
          criteria.salesPersonCodes.push(salesPersonBean.code);
          this.setState({
            criteria: criteria,
            salesPersonDatas: salesPersonDatas,
            salesPersonBean: null,
          });
        }
      }
    }
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  deleteSalesPerson = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.salesPersonCodes;
    let salesPersonDatas = this.state.salesPersonDatas;
    salesPersonDatas.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        salesPersonDatas.splice(index, 1);
      }
    });
    this.setState({ criteria: criteria, salesPersonBean: null });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowVendorQtyPopup: isShowPopup,
    });
  };
  vendorOnOrderQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let vendorPurchaseBean = new VendorPurchaseOnOrderDetailsBean();
      vendorPurchaseBean.companyCode = this.companyCode;
      vendorPurchaseBean.fabricStyleCode = rowData.fabricStyleCode;
      vendorPurchaseBean.fabricStyleShortName = rowData.fabricStyleShortName;
      vendorPurchaseBean.colorCode = rowData.colorCode;
      this.setState({ vendorPurchaseBean: vendorPurchaseBean });
      let vendorQtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      vendorQtyCriteria.companyCode = this.companyCode;
      vendorQtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      vendorQtyCriteria.colorCode = rowData.colorCode;
      vendorQtyCriteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = vendorQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching VendorOnOrder Data...",
      });
      if (rowData.vendorOnOrderQuantity != 0) {
        this.loadVendorOnOrderQtyListPage(listRequest);
      } else {
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadVendorOnOrderQtyListPage = (listRequest) => {
    if (SecurityAccessManager.CustomerServiceSalesOrderInquiry_IsAccessible()) {
      VendorService.getVendorPurchaseOnOrderDetailsForFabricStyleStatistics(
        listRequest,
        this.loadVendorOnOrderQtyResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadVendorOnOrderQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      const vendorQtyDataList =
        response.data.orderDetailsResult.onOrderInfoDetails;
      this.setState({
        vendorQtyDataList: vendorQtyDataList,
        isShowVendorQtyPopup: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateVendorOnOrderPdf = (e) => {
    if (e.detail === 1) this.generateVendorOnOrderReport(1);
  };
  generateVendorOnOrderExcel = (e) => {
    if (e.detail === 1) this.generateVendorOnOrderReport(2);
  };
  generateVendorOnOrderReport = (reportType) => {
    let vendorPurchaseBean = this.state.vendorPurchaseBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = vendorPurchaseBean.fabricStyleCode;
    criteria.colorCode = vendorPurchaseBean.colorCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new VendorOnOrderPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (SecurityAccessManager.CustomerServiceSalesOrderInquiry_IsAccessible()) {
      ReportService.generateVendorOnOrderPrintReport(
        listRequest,
        this.generateVendorOnOrderResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(2);
    }
  };
  generateVendorOnOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,

      isShowFabricStyleModule: isOpen,
      isShowSalesModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleShortName", true)
        .setStyleDetails("left", "6", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Order UOM", "orderUom", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerPO#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SO#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewSalesModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnOrderQty", "customerOnOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InTransitQty", "inTransitQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorOnOrderQty", "vendorOnOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.vendorOnOrderQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson", "salesPersonCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("City", "cityCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          showHideSecondHeader={this.showHideSecondHeader}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          salesPersonCodeOnChange={this.salesPersonCodeOnChange}
          addSalesPerson={this.addSalesPerson}
          deleteSalesPerson={this.deleteSalesPerson}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          salesPersonEnterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
          displayAutoCompleteSalesPersonList={
            this.displayAutoCompleteSalesPersonList
          }
          onCityChange={this.onCityChange}
          cityEnterKeyEvent={this.cityEnterKeyEvent}
          displayAutoCompleteCityList={this.displayAutoCompleteCityList}
        />
        <div>
          {this.state.isInquiryDatasFound && (
            <div className="mt-3">
              <CustomTable
                data={inquiryDataList}
                columns={this.inquiryColumns()}
                enableVritualizer={true}
              />
            </div>
          )}
        </div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowVendorQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateVendorOnOrderPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateVendorOnOrderExcel(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div>
              <VendorOnOrderDetailsForm
                {...this.state}
                vendorPurchaseBean={this.state.vendorPurchaseBean}
                vendorQtyDataList={this.state.vendorQtyDataList}
              />
            </div>
          }
        />
      </div>
    );
  }
}
class VendorOnOrderDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowVendorModule: false,
      isShowFabricStyleCodeModule: false,
      isShowPurchaseOrderModule: false,
      modulePopup: [],
    };
  }
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleCodeModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowVendorModule: isOpen,
      isShowFabricStyleCodeModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      moduleForPopup: [],
    });
  };
  vendorOnOrderColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Vendor#",
          "vendorCode",
          true
        )
        .setStyleDetails("left", "6", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "VendorName",
          "vendorName",
          true
        )
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleShortName", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "orderUom", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" P.OStartDate", "purchaseOrderStartDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("P.OStopDate", "purchaseOrderStopDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnOrderQty", "onOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  render() {
    let vendorPurchaseBean = this.props.vendorPurchaseBean;
    let vendorQtyDataList = this.props.vendorQtyDataList;
    return (
      <div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleCodeModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />{" "}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />{" "}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <Row>
          <Col sm="1">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              type="text"
              value={vendorPurchaseBean.fabricStyleCode}
              disabled={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="fabricStyleName"
              type="text"
              value={vendorPurchaseBean.fabricStyleShortName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleColorCode"
              type="text"
              value={vendorPurchaseBean.colorCode}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="mt-3">
              <CustomTable
                data={vendorQtyDataList}
                columns={this.vendorOnOrderColumns()}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      criteria: this.props.criteria,
      cities: [],
      isCollapsible_open: this.props.isCollapsible_open,
    };
    this.customerCodeRef = React.createRef();
    this.salesPersonCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    this.state.cities = [];
    let cities = attribute_cache.cities;
    if (cities != null || cities != undefined) {
      cities.map((cities) => {
        this.state.cities.push(cities);
      });
    }
    this.initLookupHandlers();
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.customerCodeRef.current != null) {
      this.customerCodeRef.current.focus();
    }
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.props.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.props.salesPersons,
      "SalesPerson"
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
  };
  deleteSalesPerson = (e, val, rowData) => {
    this.props.deleteSalesPerson(rowData);
  };
  onCityChange = (e) => {
    this.props.onCityChange(e);
  };
  cityEnterKeyEvent = (e) => {
    this.props.cityEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = (e) => {
    this.props.displayAutoCompleteCityList(e);
  };
  salesPersonColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "SalesPerson",
          "code",
          true
        )
        .setStyleDetails("left")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Name",
          "description",
          true
        )
        .setStyleDetails("left")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setClickDetails(false, true, this.deleteSalesPerson, <DeleteIcon />)
    );

    return columns;
  };
  // salesPersonColumnDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("SalesPerson#", "code", 0, true)
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Name", "description")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails(
  //         "Remove",
  //         <DeleteIcon />,
  //         1,
  //         false,
  //         null,
  //         false,
  //         null, //image link call back
  //         "1em", //min-width
  //         "20%", //max-width
  //         false,
  //         null,
  //         false
  //       )
  //       .setEditableDetails(
  //         false,
  //         "",
  //         null,
  //         true,
  //         this.deleteSalesPerson,
  //         false,
  //         null
  //       )
  //   );
  //   return columnList;
  // };
  addSalesPerson = (e) => {
    if (e.detail === 1) {
      this.props.addSalesPerson();
      if (this.customerCodeRef != null) {
        this.salesPersonCodeRef.current.clear();
        this.salesPersonCodeRef.current.focus();
      }
    }
  };
  customerCodeOnChange = (e) => {
    this.props.customerCodeOnChange(e);
  };
  salesPersonCodeOnChange = (e) => {
    this.props.salesPersonCodeOnChange(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) this.props.showHideSecondHeader();
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteList = () => {
    this.props.displayAutoCompleteList();
  };
  fabricCodeOnChange = (e) => {
    this.props.fabricCodeOnChange(e);
  };
  salesPersonEnterKeyEventHandler = (e) => {
    this.props.salesPersonEnterKeyEventHandler(e);
  };
  displayAutoCompleteSalesPersonList = () => {
    this.props.displayAutoCompleteSalesPersonList();
  };
  onFabricColourCodeChange = (e) => {
    this.props.onFabricColourCodeChange(e);
  };
  fabricEnterKeyEventHandler = (e) => {
    this.props.fabricEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricList = () => {
    this.props.displayAutoCompleteFabricList();
  };
  onFabricColourCodeChange = (e) => {
    this.props.onFabricColourCodeChange(e);
  };
  fabricColourEnterKeyEventHandler = (e) => {
    this.props.fabricColourEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricColorList = () => {
    this.props.displayAutoCompleteFabricColorList();
  };
  render() {
    let criteria = this.props.criteria;
    let salesPersonDatas = this.props.salesPersonDatas;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.customerCodeRef}
              name="customerCode"
              onChange={this.customerCodeOnChange}
              value={criteria.customerCode}
              placeholder="Customer"
              lookupRequired={true}
              lookupHandler={this.state.customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.customerPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteList}
              showAutoCompleteList={this.props.showAutoCompleteCustomerList}
              disabled={isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="customerName"
              value={criteria.customerName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.fabricCodeOnChange}
              name="fabricStyleCode"
              placeholder="Item"
              value={criteria.fabricStyleCode}
              lookupRequired={true}
              lookupHandler={this.state.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.fabricEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricList}
              showAutoCompleteList={this.props.showAutoCompleteFabricList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onChange}
              name="fabricStyleName"
              value={criteria.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col>
            <CollapseComponent
              isOpen={this.props.isCollapsible_open}
              onClick={(e) => this.showHideSecondHeader(e)}
            />
          </Col>
        </Row>
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>ColorCode</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onFabricColourCodeChange}
                name="colorCode"
                placeholder="colorCode"
                value={criteria.colorCode}
                lookupRequired={this.props.isShowColorLookup}
                lookupHandler={this.props.colorLookupHandler}
                enterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.fabricColourPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteFabricColorList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteFabricColorList
                }
                disabled={!this.props.isShowColorLookup}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Order Stop Date-From</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="fromOrderStopDate"
                onChange={this.onChange}
                value={criteria.fromOrderStopDate}
                disabled={isDisableFields}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Order Stop Date-To</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="toOrderStopDate"
                onChange={this.onChange}
                value={criteria.toOrderStopDate}
                disabled={isDisableFields}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>City</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCityChange}
                name="cityCode"
                placeholder="cityCode"
                value={criteria.cityCode}
                lookupRequired={true}
                lookupHandler={this.state.cityLookupHandler}
                enterKeyEventHandler={this.cityEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
                disabled={isDisableFields}
              ></InputTextbox>
            </Col>
          </Row>
        )}
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="1">
              <FormLabel>SalesPerson</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.salesPersonCodeRef}
                name="salesPersonCode"
                onChange={this.salesPersonCodeOnChange}
                value={criteria.salesPersonCode}
                lookupRequired={true}
                lookupHandler={this.state.salesPersonLookupHandler}
                enterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.salesPersonPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteSalesPersonList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteSalesPersonList
                }
                disabled={isDisableFields}
              />
            </Col>
            <Col sm="1">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addSalesPerson(e)}
                disabled={isDisableFields}
              >
                Add
              </Button>
            </Col>
          </Row>
        )}
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="4">

              <CustomTable
                data={salesPersonDatas}
                columns={this.salesPersonColumnDefinitions()}
                label={"SalesPerson Data List"}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

function CustomerServiceSalesOrderInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CustomerServiceSalesOrder {...props} name="" /> <br />
    </div>
  );
}

export default CustomerServiceSalesOrderInquiry;
